export default [{
  path: '/statement',
  meta: {
    title: '统计报表'
  },
  components: {
    right: () => import('@/views/statement/Index.vue')
  }
}]
